import styled from 'styled-components'
import { device } from '@styles/global/breakpoints'

export const HeroImageWrapper = styled.div<{ backgroundColor: string }>`
  background-repeat: no-repeat;
  height: 270px;
  display: flex;
  background-color: ${props => props.backgroundColor};
  position: relative;
  
  @media ${device.tablet}{
    height: calc(100vw * .70);
  }
  
  @media ${device.laptop}{
    max-height: 660px;
  }

  .hero__img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 960px;
    transform: translateX(-50%) translateY(-50%);
    max-width: 2300px;

    @media ${device.tablet}{
      width: calc(100vw * 2.5);
    }
  }
`

export const HeroImage2Wrapper = styled.div<{ backgroundColor: string }>`
  background-repeat: no-repeat;
  height: 270px;
  display: flex;
  background-color: ${props => props.backgroundColor};
  
  @media ${device.tablet}{
    height: calc(100vw * .70);
  }
  
  @media ${device.laptop}{
    max-height: 760px;
  }
  .gatsby-image-wrapper{
    width: 100%;
  }
  .hero__img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 960px;
    transform: translateX(-50%) translateY(-50%);
    max-width: 2400px;

    @media ${device.tablet}{
      width: calc(100vw * 2.5);
    }
    
    // ADDED FOR GATSBY_IMAGE_PLUGIN ADDED
    &.gatsby-image-wrapper{
     position: relative;
    }
  }
`

export const StdHeroWrapper = styled.div<{ backgroundColor: string | null }>`
  display: flex;
  background: ${props => props.backgroundColor ? props.backgroundColor : props.theme.backgroundPrimary};
`
export const StdHeroInner = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
`
